module.exports = {"id":"197937","name":"Papy Djilobodji","rating":"76","photo":"./data/images/photos/2/197937.png","club":{"name":"Dijon FCO","logo":"./data/images/clubs/DijonFCO.png"},"positions":["DC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PapyDjilobodji0.json
// module id = 3367
// module chunks = 0